import { camelCaseKeys, useFlags } from 'launchdarkly-react-client-sdk';

export const defaultFlags = {
  'verifx-edn-gpt': false,
  'oec-checkout-block-trade-in-leases': false,
  'verifx-notarize': false,
  'verifx-enable-persona-codl-cr': false,
  'verifx-enable-codl-magic-links': false,
  'verifx-exclude-per-diem': false,
  'verifx-disable-odometer-bundle': false,
  'enable-pre-delivery-cr': false,
  'verifx-enable-cv-customer-requests': false,
  'verifx-dl-magic-session': false,
  'verifx-improved-dodo': {
    enableAutoPullTasks: false,
    enableLienPayoffDocument: false,
    enableOdometerDocument: false,
    enableTitleRegUploadThinker: false
  },
  'verifx-income-ir': false,
  'verifx-enable-additional-income-ir': false,
  'opd-purchase-ui-separation': false
};

type CamelCase<S extends string> = S extends `${infer T}-${infer U}`
  ? `${T}${Capitalize<CamelCase<U>>}`
  : S;

type FeatureFlags = {
  [K in keyof typeof defaultFlags as CamelCase<K>]: (typeof defaultFlags)[K];
};

const defaultCamelCasedFlags = camelCaseKeys(defaultFlags) as FeatureFlags;

export const useFeatureFlags = () => {
  const flags = useFlags<FeatureFlags>();
  return { ...defaultCamelCasedFlags, ...flags };
};
